import React, { useEffect, useState } from "react";
import Api from "../../services/api";
import loadingimg from "../../assets/loading.png"
import FilterBox from "../../Components/filterBox/filterBox";
import Select from "../../Components/select/select";
import DatePicker from "../../Components/datePicker/datePicker";
import Button from '../../Components/commonButton/commonButton';
import CardInfo from "../../Components/cardInfo/cardInfo";
import MessageTable from "../../Components/messageTable/MessageTable";
import TableList from "../../Components/tableList/TableList";
import moment from "moment";
//import { faGear, faClock, faCircleExclamation, faCircleRadiation } from "@fortawesome/free-solid-svg-icons";
import "./dashboardStops.css";
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Pie, PieChart, ResponsiveContainer } from 'recharts';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";

const reportDashboardStops = () => {

    /*States visuais*/
    const [control,setControl] = useState([1]);
    const [loading,setLoading] = useState(false);

    /*States referentes aos cards*/
    const [totalTimeStop,setTotalTimeStop] = useState("00:00:00");
    const [totalStops, setTotalStops] = useState(0);

    const [maxStopTime, setMaxStopTime] = useState("00:00:00");
    const [nameMaxStopTime,setNameMaxStopTime] = useState("Motivo");

    const [maxReason, setMaxReason] = useState(0);
    const [nameMaxReason, setNameMaxReason] = useState("Motivo");

    /*States referente ao filtro*/
    const [factories, setFactories] = useState([]);
    const [initialFactories, setInitialFactories] = useState([]);
    const [factory, setFactory] = useState([]);

    const [workshifts, setWorkshifts] = useState([]);
    const [initialWorkshifts, setInitialWorkshifts] = useState([]);
    const [workshift, setWorkshift] = useState([]);

    const [departaments, setDepartaments] = useState([]);
    const [initialDepartaments, setInitialDepartaments] = useState([]);
    const [departament, setDepartament] = useState([]);

    const [machines, setMachines] = useState([]);
    const [initialMachines, setInitialMachines] = useState([]);
    const [machine, setMachine] = useState([]);

    const [dateIniti, setDateIniti] = useState(null);
    const [dateEnd, setDateEnd] = useState(null);

    /*State referente ao gráfico*/

    const [dataChart, setDatachart] = useState([{name: "Motivo",tempo: 0}]);
    const [dataPieChart, setDataPieChart] = useState([{name: "Motivo",tempo: 0}]);

    const [tableData, setTableData] = useState([]);

    const pieData = [
        {name: "Refugo", value: 15},
        {name: "Descanso", value: 10},
        {name: "Troca de turno", value: 11},
        {name: "Pardada Crítica", value: 12},
        {name: "Janta", value: 15},
    ]

    //Use Effect para preencher todos os selects.
    useEffect(() => {
        function factory (){
            let array = [];
            Api.get("/factorys")
            .then((response)=>{
                response.data.forEach((element) => {
                    array.push({
                        value: element.id,label: element.description
                    })
                })
                console.log(response.data);
                if(array.length > 0){
                    setFactories([...array]);
                    setInitialFactories(response.data);
                }
            })
        }
        
        function departaments (){
            let array = [];
            Api.get("/departments")
            .then((response)=>{
                //console.log(response);
                array.push({value: null, label: "Todos"})
                response.data.forEach((element) => {
                    array.push({
                        value: element.code,label: element.description
                    })
                })

                if(array.length > 0){
                    setInitialDepartaments(response.data);
                }

            })
        }

        function machines (){
            let array = [];
            Api.get("/machines")
            .then((response)=>{
                //console.log(response);
                array.push({value: null, label: "Todos"})
                response.data.forEach((element) => {
                    array.push({
                        value: element.code,label: element.description
                    })
                })

                if(array.length > 0){
                    setInitialMachines(response.data);
                }

            })
        }

        function workshifts(){
            let array = [];
            Api.get("/work-shifts/")
            .then((response)=>{
                array.push({value: null, label: "Todos"})
                response.data.forEach((element) => {
                    
                    array.push({
                        value: element.id,label: element.code
                    })
                })

                if(array.length > 0){
                    setWorkshifts(array);
                    setInitialWorkshifts(response.data);
                }

            })
        }

        machines();
        departaments();
        factory();
        workshifts();
        messageBox();
        let now = moment().format('YYYY-MM-DD');

        setDateIniti(now);
        setDateEnd(now);

    },[]);

    const sendData =  () => {
        //console.log(departament)
        setLoading(true);
        if(validation()){
            setControl([...[1]]);
        }else{
            setLoading(false);
        }
        
    }

    const compare = (a,b) => {
        if(a.Tempo > b.Tempo){
            return -1
        }else{
            return 1
        }
        return 0
    }

    const compareTable = (a,b) => {
        if(a.Quantidade > b.Quantidade){
            return -1
        }else{
            return 1
        }
        return 0
    }

    const comparePie = (a,b) => {
        if(a.value > b.value){
            return -1
        }else{
            return 1
        }
        return 0
    }

    useEffect(()=>{

        setDatachart([{name: "Motivo",tempo: 0}]);
        setDataPieChart([{name: "Motivo", value: 0}]);
        setTableData([]);

        setTotalTimeStop("00:00:00");
        setTotalStops(0);

        setMaxStopTime("00:00:00");
        setNameMaxStopTime("Motivo");

        setMaxReason(0)
        setNameMaxReason("Motivo");

        let machinevar;

        if(machine == null || ((typeof machine.description == "undefined") && (typeof machine.code == "undefined")) ){
            machinevar = null;
        }else{
            machinevar = machine.description+machine.code;
        }

        const params = {
            machine_code: machinevar,
            ini_date: dateIniti,
            fin_date: dateEnd,
            department: (departament == null ? null : departament.description),
            factory: factory.description,
            workshift: workshift
        }

         Api.get("/completeIntvl",{params: params}).then((resp)=>{
            //console.log(params)
            if(resp.data.payload.length > 0){
                let tData = [];
                let dChart = [];
                let pieChart = [];
                let tTimeStop = 0;
                let tStops = 0;
                let mStopTime = 0;
                let nmStopTime = "Motivo";
                let mReason = 0;
                let nmReason = "Motivo";
                //resp.data.payload = resp.data.payload.slice(0,5);
                resp.data.payload.forEach(element => {
                    
                    let aux = parseInt(element.time_stop_secs);
                    tData.push({Motivo: element.description, Quantidade: element.stop_count, "Tempo total": convertSecondsToMinute("timeTotal",element.time_stop_secs*1000), "Tempo médio" : convertSecondsToMinute("timeMedio",(element.time_stop_secs*1000)/element.stop_count)})
                    dChart.push({name: element.description.substring(0,20) + "...", Tempo: aux});
                    pieChart.push({name: element.description.substring(0,27) + "...", value: element.stop_count});
                    tTimeStop += (element.time_stop_secs*1000);
                    tStops += element.stop_count;
                    if((element.time_stop_secs*1) >= mStopTime){
                        mStopTime = element.time_stop_secs;
                        nmStopTime = element.description;
                    }
                    if(element.stop_count > mReason){
                        mReason = element.stop_count;
                        nmReason = element.description;
                    }

                });

                pieChart.sort(comparePie);
                pieChart = pieChart.slice(0,5);
                dChart.sort(compare);
                tTimeStop = tTimeStop;
                mStopTime = mStopTime*1000;
                tData.sort(compareTable);
                setTableData([...tData]);
                setMaxReason(mReason);
                setNameMaxReason(nmReason);
                convertSecondsToMinute("totalTimeStop",tTimeStop);
                convertSecondsToMinute("maxStopTime",mStopTime);
                setNameMaxStopTime(nmStopTime);
                setTotalStops(tStops);
                setDatachart(dChart.slice(0,5));
                setDataPieChart(pieChart);
            }
            setLoading(false);
            
        }).catch(()=>{setLoading(false);});
      },[control])

    const convertSecondsToMinute = (namestate,time) =>{

        let segundos = ( time / 1000 ) % 60;
        segundos = parseInt(segundos,10);
        if(segundos < 10){
            segundos = "0" + segundos;
        }
        let minutos = (time / 60000) % 60;
        minutos = parseInt(minutos,10);
        if(minutos < 10){
            minutos = "0" + minutos;
        }
        let horas = (time / 3600000);
        horas = parseInt(horas,10);
        if(horas < 10){
            horas = "0" + horas;
        }

        if(namestate == "totalTimeStop"){

            setTotalTimeStop(horas + ":" + minutos + ":" + segundos);
        }

        if(namestate == "maxStopTime"){

            setMaxStopTime(horas + ":" + minutos + ":" + segundos);
        }

        if(namestate == "timeMedio" || namestate == "timeTotal"){
            return (horas + ":" + minutos + ":" + segundos);
        }
    }

    const saveDateIniti = (element) => {
        let aux = element.toString();
        let year = aux.substring(6,10);
        let month= aux.substring(3,5);
        let day= aux.substring(0,2);
        /*if(day < 10){
            day = "0" + day;
        }*/
        setDateIniti(year + "-" + month + "-" + day);
        
    }

    const saveDateEnd = (element) => {

        let aux = element.toString();
        let year = aux.substring(6,10);
        let month= aux.substring(3,5);
        let day= aux.substring(0,2);
        /*
        if(day < 10){
            day = "0" + day;
        }
        */
      
        setDateEnd(year + "-" + month + "-" + day);
        
    }
    const loadDepartments = (value) => {
        let array = [];
        array.push({
            value: null,label: "Todos"
        })
        setLoading(true);
        if(value != null){
            const dep = initialDepartaments.filter(element => element.id_factory == value);
            if(dep.length > 0){
            dep.map((element)=>{
                array.push({
                    value: element.id,label: element.description
                })
            })
            setDepartaments([...array]);
            }
        }else{
            initialDepartaments.map((element)=>{
                array.push({
                    value: element.id,label: element.description
                })
            })
            setDepartaments([...array]);
        }
        
        
        setLoading(false);
    }

    const loadMachines = (value) => {
        let array = [];
        array.push({
            value: null,label: "Todos"
        })
        setLoading(true);
        if(value != null){
            
            const dep = initialMachines.filter(element => element.id_department == value);
            if(dep.length > 0){
                dep.map((element)=>{
                    array.push({
                        value: element.id,label: element.description+element.code
                    })
                })
                setMachines([...array]);
            }
        }else{
            initialMachines.map((element)=>{
                array.push({
                    value: element.id,label: element.description+element.code
            })}
            )

            setMachines([...array]);
        }
        
        setLoading(false);
    }

    const selectFactory = (value) =>{
        if(value != null){
            const factorie = initialFactories.find(element => element.id == value)
            console.log(value)
            setFactory(factorie);
            loadDepartments(value);
        }else{
            setFactory(null);
            loadDepartments(null);
        }
       
    }

    const selectDepartament = (value) =>{
        if(value != null){
            const depart = initialDepartaments.find(element => element.id == value)
            setDepartament(depart);
            loadMachines(value);
        }else{
            setDepartament(null);
            loadMachines(null);
        }
        
    }

    const selectWorkshift = (value) => {
        if(value != null){
            const work_shift = initialWorkshifts.find(element => element.id == value);
            let array = [];
            array.push({value: work_shift.id,label: work_shift.code});
            setWorkshift(work_shift.code);
        }else{
            setWorkshift(null);
        }
        
    }

    const selectMachine = (value) =>{
        if(value != null){
            const aux = initialMachines.find(element => element.id == value)
            setMachine(aux);
        }else{
            setMachine(null);
        }
        
    }


    const COLORS = ['#000547', '#00471b', '#d5b810', '#d57910','#930b0b'];



    const integerToTime = () => {
        let axis = document.getElementsByClassName("recharts-cartesian-axis-ticks");
        if(axis.length > 1){
        let yaxis = axis[1].children;
        let numElementsYAxis = yaxis.length;
        //Esse if tá aqui para controle, pois por conta da re-renderização essa função roda 2 vezes.
        if(yaxis[1].children[1].children[0].innerHTML.includes(":") == false || isNaN(yaxis[0].children[1].children[0].innerHTML) == false){
            for(let i = 0; i < numElementsYAxis;i++){
                yaxis[i].children[1].children[0].innerHTML = convertSecondsToMinute("timeMedio",(parseInt(yaxis[i].children[1].children[0].innerHTML,10)) * 1000);
            }
        }
        }
        

    }

    const overflowDisable = (status) => {
        let pag = document.getElementById('root');
        if(status === 'disable'){
            pag.style.overflowY = 'hidden';
        }
        else{
            pag.style.overflowY = 'visible';
        }
    }

    const validation = () => {
        if(factory === null || (dateIniti === null || dateIniti === "d da-l-In") || (dateEnd === null || dateEnd === "d da-l-In")){
            let messageBox = document.getElementsByClassName("messageBox");
            messageBox[0].hidden = false;
            let titulo = document.getElementById("tituloMB");
            let mensagem = document.getElementById("mensagemMB");
            titulo.innerHTML = "ERRO";
            mensagem.innerHTML = "Preencha todos os campos do filtro!";
            return false;
        }else{
            return true;
        }
    }

    const CustomTooltip = ({active,payload,label}) => {
        if(active && payload && payload.length){
            return (
                <div className="custom-tooltip">
                    <p className="label">{`${label} : ${convertSecondsToMinute("timeMedio",(parseInt(payload[0].value,10)) * 1000)}`}</p>
                </div>
            );
        }

        return null;
    }

    const messageBox = () => {
        let button = document.getElementById("messageBoxButton");
        let box = document.getElementsByClassName("messageBox");
        box[0].hidden = true;
        button.addEventListener("click",()=>{
            box[0].hidden = true;
        });
    }
    return (
        <div className="containerDash">
            <div className="messageBox">
                <div id="message">
                    <h2 id="tituloMB">Título</h2>
                    <h3 id="mensagemMB">Mensagem</h3>
                    <div><button id="messageBoxButton">OK</button></div>
                </div>
            </div>
            {loading ?(<div className="loading">
                {overflowDisable("disable")}
                <img src={loadingimg} width="100px" height="100px"/>
                <div>Carregando...</div>
            </div>):( <>{overflowDisable("enable")}</>)}
            
            <div className="boxDash headerDash">
                <h1>Dashboard de paradas</h1>
                <div className="filterDash">
                <div className="elementFilter filterDashboard" type="input">
                        <Select name={'fabrica'} arrData={factories} handleSelect={selectFactory} label="Fábrica" autoSelect={true}/>
                    </div>
                    <div className="elementFilter filterDashboard" type="input">
                        <Select name={'setor'} arrData={departaments} handleSelect={selectDepartament} label="Setor"/>
                    </div>
                    <div className="elementFilter filterDashboard" type="input">
                        <Select name={'turno'} arrData={workshifts} handleSelect={selectWorkshift} label="Turno"/>
                    </div>
                    <div className="elementFilter filterDashboard" type="input">
                        <Select name={'maquina'} arrData={machines} handleSelect={selectMachine} label="Máquina"/>
                    </div>
                    <div className="elementFilter" type="input">
                        <DatePicker className="dashboardDatePicker" name={'data_inicial'} parentCallback={saveDateIniti} title="Data inicial"/>
                    </div>
                    <div className="elementFilter" type="input">
                        <DatePicker className="dashboardDatePicker" name={'data_final'} parentCallback={saveDateEnd} title="Data final"/>
                    </div>
                    <div className="buttonDash" type="input">
                        <Button title="Filtrar" icon="" parentCallback={sendData}/>
                    </div>
                </div>
                </div>
                <div className="boxDash">
                    <div className="cardsInfo">
                        <div className="cardInfo" id="card1">
                            <CardInfo bordercolor={'red'} title={'Tempo total de parada'} info1={totalTimeStop}></CardInfo>
                        </div>
                        <div className="cardInfo" id="card2">
                            <CardInfo bordercolor={'blue'} title={'Quantidade total de paradas'} info1={totalStops + " paradas"}></CardInfo>
                        </div>
                        <div className="cardInfo" id="card3">
                            <CardInfo bordercolor={'green'} title={'Maior tempo de parada'} info1={maxStopTime} info2={nameMaxStopTime}></CardInfo>
                        </div>
                        <div className="cardInfo" id="card4">
                            <CardInfo bordercolor={'brown'} title={'Maior quantidade de acionamentos'} info1={nameMaxReason} info2={maxReason + ' paradas'}></CardInfo>
                        </div>
                    </div>
                    <div className="miniBoxDash">
                        <div className="dashChart" >
                            <div className="dashChartHeader">
                                <h4>Paradas no período</h4>
                                <div className="icons">
                                    <FontAwesomeIcon icon={faPrint} className="print"></FontAwesomeIcon>
                                </div>
                            </div>
                            <ResponsiveContainer width="100%" height="100%">
                            <BarChart
                                
                                data={dataChart}
                                margin={{
                                    top: 20,
                                    right: 30,
                                    left: 20,
                                    bottom: 5
                                }}
                            >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="name" fontSize={"10px"} allowDataOverflow interval={0}/>
                                <YAxis dataKey="Tempo" fontSize={"10px"}/>
                                <Tooltip content={<CustomTooltip />}/>
                                <Legend />
                                <Bar dataKey="Tempo" stackId="a" fill="#FFD700" />
                            </BarChart>
                            </ResponsiveContainer>
                            {integerToTime()}
                        </div>
                        <div className="listTopStops">
                            <div className="dashChartHeader">
                                <h4>Top 5 paradas</h4>
                                <div className="icons">
                                    <FontAwesomeIcon icon={faPrint} className="print"></FontAwesomeIcon>
                                </div>
                            </div>
                                <PieChart  width={400} height={400}>
                                    <Pie
                                        dataKey="value"
                                        isAnimationActive={false}
                                        data={dataPieChart}
                                        outerRadius={100}
                                        fill="#8884d8"
                                        label
                                        cx={"50%"}
                                        cy={"50%"}
                                    >
                                        {pieData.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]}/>
                                        ))}
                                    </Pie>
                                    <Tooltip />
                                    <Legend/>
                                </PieChart>
                        </div>
                    </div>
                </div>
                <div className="boxDash" id="textInfo">
                    <h3>Informações Complementares</h3>
                    <div className="TableReport" id="tabela">
                        {loading ? (<></>) : (
                            <>
                        {tableData.length > 0 ? (

                        <TableList data={tableData}></TableList>

                        ) : (

                        <MessageTable message={"Sem dados para processar."} />

                        )}
                        </>)}
                    </div>
                </div>
        </div>
    )
}

export default reportDashboardStops;